/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ExternalOAuthServerForm,
  ExternalOAuthServerForm$Outbound,
  ExternalOAuthServerForm$outboundSchema,
} from "./externaloauthserverform.js";

export type AddExternalOAuthServerRequestBody = {
  externalOauthServer: ExternalOAuthServerForm;
};

/** @internal */
export type AddExternalOAuthServerRequestBody$Outbound = {
  external_oauth_server: ExternalOAuthServerForm$Outbound;
};

/** @internal */
export const AddExternalOAuthServerRequestBody$outboundSchema: z.ZodMiniType<
  AddExternalOAuthServerRequestBody$Outbound,
  AddExternalOAuthServerRequestBody
> = z.pipe(
  z.object({
    externalOauthServer: ExternalOAuthServerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      externalOauthServer: "external_oauth_server",
    });
  }),
);

export function addExternalOAuthServerRequestBodyToJSON(
  addExternalOAuthServerRequestBody: AddExternalOAuthServerRequestBody,
): string {
  return JSON.stringify(
    AddExternalOAuthServerRequestBody$outboundSchema.parse(
      addExternalOAuthServerRequestBody,
    ),
  );
}
